import { useDefaultAppContexts } from '@hivebrite/frontoffice-default-app-contexts';
export const getNewsShowRoute = ({ id, topicId, whitelabelActivated = false, whitelabelName, }) => {
    if (topicId && (!whitelabelActivated || !whitelabelName)) {
        return `/topics/${topicId}/news/${id}`;
    }
    return `/news/${id}`;
};
export const useNewsRouter = () => {
    const { currentTopic } = useDefaultAppContexts();
    return {
        getNewsShowRoute: (id) => getNewsShowRoute({
            id,
            topicId: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.id,
            whitelabelActivated: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.whitelabelActivated,
            whitelabelName: currentTopic === null || currentTopic === void 0 ? void 0 : currentTopic.whitelabelName,
        }),
    };
};
//# sourceMappingURL=useNewsRouter.js.map